module.exports = __webpack_public_path__ + "static/img/m_home_advantage_service@3x.8524c56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_home_advantage_service@3x.png
// module id = gl/A
// module chunks = 1